import { render } from "./TransportInpost.vue?vue&type=template&id=10e57880"
import script from "./TransportInpost.vue?vue&type=script&lang=js"
export * from "./TransportInpost.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__